"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useExampleSentenceTranslation = exports.ExampleSentenceTranslationProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ExampleSentenceTranslationContext = /*#__PURE__*/_react["default"].createContext(null);
var useTranslation = function useTranslation() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    parts = _ref.parts,
    translation = _ref.translation,
    languageId = _ref.languageId,
    revealed = _ref.revealed,
    _ref$allowTranslation = _ref.allowTranslation,
    allowTranslation = _ref$allowTranslation === void 0 ? false : _ref$allowTranslation,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible;
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showTranslation = _React$useState2[0],
    setShowTranslation = _React$useState2[1];
  _react["default"].useEffect(function () {
    return setShowTranslation(false);
  }, [parts, revealed, visible]);
  var canToggle = Boolean(visible && (revealed || allowTranslation) && (translation === null || translation === void 0 ? void 0 : translation.text));
  var translated = canToggle && showTranslation;
  var toggleLanguage = function toggleLanguage(event) {
    var _event$stopPropagatio;
    event === null || event === void 0 || (_event$stopPropagatio = event.stopPropagation) === null || _event$stopPropagatio === void 0 || _event$stopPropagatio.call(event);
    if (canToggle) setShowTranslation(function (value) {
      return !value;
    });
  };
  return {
    canToggle: canToggle,
    translated: translated,
    toggleLanguage: toggleLanguage,
    languageId: translated ? translation.languageId : languageId
  };
};
var ExampleSentenceTranslationProvider = exports.ExampleSentenceTranslationProvider = function ExampleSentenceTranslationProvider(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  var value = useTranslation(props);
  return /*#__PURE__*/_react["default"].createElement(ExampleSentenceTranslationContext.Provider, {
    value: value
  }, children);
};
var useExampleSentenceTranslation = exports.useExampleSentenceTranslation = function useExampleSentenceTranslation(props) {
  var context = _react["default"].useContext(ExampleSentenceTranslationContext);
  var local = useTranslation(props);
  return context || local;
};